const sides = ['Top', 'Right', 'Bottom', 'Left']
const legacyEdges = [10, 16, 15, 10]
const own = (value, key) => Object.prototype.hasOwnProperty.call(value, key)

function number (value, fallback, max) {
  if ((typeof value !== 'number' && typeof value !== 'string') || (typeof value === 'string' && !value.trim())) return fallback
  const parsed = Number(value)
  return Number.isFinite(parsed) ? Math.max(0, Math.min(max, parsed)) : fallback
}

// 切片使用原图像素；显示边宽使用画布像素，两者不能随组件宽高同比增长。
export function imageFrameSettings (option = {}, kind = 'img') {
  const defaults = kind === 'imgborder' ? legacyEdges : [40, 40, 40, 40]
  const slice = sides.map((side, index) => number(option['frameSlice' + side], defaults[index], 10000))
  const border = own(option, 'frameBorderWidth')
    ? sides.map(() => number(option.frameBorderWidth, 16, 512))
    : kind === 'imgborder' ? legacyEdges.slice() : [16, 16, 16, 16]
  return { slice, border, fill: option.frameFill !== false }
}

export function imageFrameStyle (option = {}, source, kind = 'img', width, height) {
  const settings = imageFrameSettings(option, kind)
  const limit = value => Number.isFinite(Number(value)) && Number(value) > 0 ? Number(value) / 2 : Infinity
  const border = settings.border.map((value, index) => Math.min(value, limit(index % 2 ? width : height)))
  return {
    width: '100%', height: '100%', display: 'block',
    boxSizing: 'border-box', borderStyle: 'solid', borderColor: 'transparent',
    borderWidth: source ? border.map(value => value + 'px').join(' ') : '0px',
    borderImageSource: typeof source === 'string' && source ? 'url(' + JSON.stringify(source) + ')' : 'none',
    borderImageSlice: settings.slice.join(' ') + (settings.fill ? ' fill' : ''),
    borderImageRepeat: 'stretch', borderImageOutset: '0', borderImageWidth: '1',
    backgroundColor: option.backgroundColor || (kind === 'imgborder' ? 'rgba(180, 181, 198, 0.1)' : 'transparent'),
    backgroundClip: 'padding-box', opacity: number(option.opacity, 1, 1)
  }
}

function hasFrameOptions (option) {
  return ['frameBorderWidth', 'frameFill', ...sides.map(side => 'frameSlice' + side)].some(key => own(option, key))
}

function replaceImage (node, style) {
  if (!node) return node
  if (node.tag === 'img') {
    // 保留旧组件的事件、类名和宽高，仅把整图替换为九宫格背景，避免重复绘制原图。
    node.tag = 'div'
    const data = node.data || {}, attrs = { ...data.attrs }
    delete attrs.src
    delete attrs.srcset
    node.data = { ...data, attrs, style: [data.style, style] }
  } else if (node.children) node.children.forEach(child => replaceImage(child, style))
  return node
}

// 沿用原 Avue 实例，保留图片数据绑定、事件及旋转，不改第三方压缩库或旧项目默认外观。
export function installImageFrameRuntime (Vue) {
  if (Vue.__imageFrameRuntime) return
  Vue.__imageFrameRuntime = true
  Vue.mixin({
    beforeCreate () {
      if (!['avue-echart-img', 'avue-echart-imgborder'].includes(this.$options.name)) return
      const kind = (this.$options.name || '').replace(/^avue-echart-/, '')
      if (kind === 'img' && this.$options.render) {
        const original = this.$options.render
        this.$options.render = function (...args) {
          const node = original.apply(this, args)
          if (!this.option || this.option.imageSizing !== 'slice') return node
          return replaceImage(node, imageFrameStyle(this.option, this.dataChart && this.dataChart.value, kind, this.width, this.height))
        }
      } else if (kind === 'imgborder' && this.$options.computed && this.$options.computed.styleImgName) {
        const original = this.$options.computed.styleImgName
        const getter = typeof original === 'function' ? original : original.get
        this.$options.computed = { ...this.$options.computed,
          styleImgName () {
            const previous = getter.call(this)
            if (!this.option || !hasFrameOptions(this.option)) return previous
            return { ...previous, ...imageFrameStyle(this.option, this.dataChart, kind, this.width, this.height) }
          }
        }
      }
    }
  })
}
